import gql from "graphql-tag"

const mutation = gql`
  mutation DeleteCompanyNewsTile($tenantId: String!, $tiles: [CompanyNewsTileInput!]!) {
    deleteCompanyNewsRow(tenantId: $tenantId, tiles: $tiles)
  }
`

export const toString = mutation.loc.source.body

export default mutation
